export default {"src":"/_next/static/media/menu-colapse-mobile.c202a7da.svg","height":32,"width":56,"blurWidth":0,"blurHeight":0};